import { createPaginator } from "@smithy/core";
import { DescribeProjectsCommand, } from "../commands/DescribeProjectsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateDescribeProjects = createPaginator(RekognitionClient, DescribeProjectsCommand, "NextToken", "NextToken", "MaxResults");
